var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formPlaceholders
    ? _c(
        "div",
        { staticClass: "form" },
        [
          _c("vue-form-generator", {
            ref: "vfg",
            attrs: {
              schema: _vm.schema,
              model: _vm.model,
              options: _vm.formOptions,
              tag: "div",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }